/*
 * jQuery dropdown: A simple dropdown plugin
 *
 * Inspired by Bootstrap: http://twitter.github.com/bootstrap/javascript.html#dropdowns
 *
 * Copyright 2011 Cory LaViska for A Beautiful Site, LLC. (http://abeautifulsite.net/)
 *
 * Dual licensed under the MIT or GPL Version 2 licenses
 *
*/
if(jQuery) (function($) {

	$.extend($.fn, {
		absdropdown: function(method, data) {

			switch( method ) {
				case 'hide':
					hideDropdowns();
					return $(this);
				case 'attach':
					return $(this).attr('data-dropdown', data);
				case 'detach':
					hideDropdowns();
					return $(this).removeAttr('data-dropdown');
				case 'disable':
					return $(this).addClass('dropdown-disabled');
				case 'enable':
					hideDropdowns();
					return $(this).removeClass('dropdown-disabled');
			}

		}
	});

	function showMenu(event) {

		//console.log("show");

		var trigger = $(this),
			dropdown = $( $(this).attr('data-dropdown') ),
			isOpen = trigger.hasClass('dropdown-open'),
			isExtended = trigger.hasClass('dropdown-extended');

		event.preventDefault();
		event.stopPropagation();

		hideDropdowns();

		if ( isOpen || trigger.hasClass('dropdown-disabled') ) return;

		positionatePopElement(trigger, dropdown);
		trigger.addClass('dropdown-open');

		dropdown.show();

		trigger.trigger("shown.dropdown");
		dropdown.trigger("shown.dropdown");


		//trigget.data("event")

		//console.dir(dropdown);

	};

	function hideDropdowns(event)
	{
		var targetGroup = event ? $(event.target).parents().addBack() : null;
		if( targetGroup && targetGroup.is('.dropdown-menu') && !targetGroup.is('A') ) return;

		$('body').find("button.dropdown-open,div.dropdown-open").each(function()
		{
//			console.dir($(this));
			var mDD = $(this).data('dropdown');
			if(typeof(mDD)!=="undefined")
			{
				var $DD = $(mDD);
				$(this).removeClass("dropdown-open").trigger("hidden.dropdown");
				$DD.hide().trigger("hidden.dropdown");
			}
		});

		/****
		$('BODY')
			.find('.dropdown-menu:not(.nav .dropdown-menu, .dropdown-toggle + .dropdown-menu)')
			.hide()
			.trigger("hidden.dropdown")
			.end()
			.find('[data-dropdown]')
			.trigger("hidden.dropdown")
			.removeClass('dropdown-open');
		***/

	};

	$(function () {
		$('BODY').on('click.dropdown', '[data-dropdown]', showMenu);
		$('HTML').on('click.dropdown', hideDropdowns);
		// Hide on resize (IE7/8 trigger this when any element is resized...)
		if( !$.browser.msie || ($.browser.msie && $.browser.version >= 9) ) {
			$(window).on('resize.dropdown', hideDropdowns);
		}
	});

})(jQuery);